import { createApp } from 'vue'
import App from './App.vue'
import { i18n } from './locales'
import { decryptText } from './directives'
import './styles/index.css'
import './xp/xp.css'

const app = createApp(App)
app.use(i18n)
app.directive('decrypt-text', decryptText)
app.mount('#app')
